import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'src/shared/components/tooltip'
import ButtonContainer from './ui/button-container'
import ButtonUi from './ui/button-ui'

export interface ButtonProps {
  onClick: () => void
  children: string // unfortunately not real children, i18n key
  helpMessage?: string
  shadow?: boolean
  small?: boolean
  wide?: boolean
  styles?: Record<string, string>
}

const Button = ({
  children,
  helpMessage,
  onClick,
  styles,
  small = false,
  wide = false,
  shadow = false,
}: ButtonProps) => {
  const { t } = useTranslation()

  return (
    <ButtonContainer>
      <ButtonUi
        onClick={onClick}
        small={small}
        wide={wide}
        shadow={shadow}
        styles={styles}
      >
        {t(children)}
      </ButtonUi>
      {helpMessage && <Tooltip message={t(helpMessage)} />}
    </ButtonContainer>
  )
}

export default Button
